var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('btn',{attrs:{"cssClass":"btn btn-secondary","icon":"fas fa-cloud-download-alt","click":_vm.downloadCsv}})}
var staticRenderFns = []

export { render, staticRenderFns }